<template>

    <section class="dd-m-review">
        <div class="dd-l-container__wrapper dd-l-container__wrapper--content dd-l-container__wrapper--grid">
            <div class="dd-m-review__container">
                <h2 class="dd-m-review__title">{{getTranslateString('Reviews & Reviews')}}</h2>

                <star-rating active-color="#FF9E00" v-model="user.rating"></star-rating>

                <div class="dd-m-review__rating">[ {{product.rating}} / 5.0 ]</div>
                <div class="dd-m-review__total">{{product.reviews}} {{getTranslateString('reviews')}}</div>

                <div class="dd-m-review__description">
                    Avalie as fragrâncias da Avon e escreva uma resenha baseada nas suas impressões do
                    perfume, frasco, embalagem e qualidade do produto como um todo.
                </div>

                <form v-on:submit.prevent="send" class="dd-m-form">
                    <textarea v-model="user.review" class="dd-m-form__custom-textarea" name="resenha"
                              placeholder="Write a review"></textarea>

                    <div class="dd-m-alert dd-m-alert--danger" v-if="errors.length">
                        <span v-for="(item, index) in errors" :key="index">
                            {{item}}
                        </span>
                    </div>

                    <vue-ladda button-class="dd-m-button dd-m-button--auto dd-m-button--light"
                               :loading="loading">
                        Submit
                    </vue-ladda>

                </form>

                <list-light-content :product-id="product.id" per-page="3"></list-light-content>
            </div>
        </div>

        <modal-simple-success title="Review sent successfully" name="client-review"
                              modal-ref="ClientReview"></modal-simple-success>
    </section>

</template>
<script>
    import ProductService from '../../providers/api/product-service';
    import AuthService from '../../providers/api/auth-service';
    import StarRating from "vue-star-rating/src/star-rating";
    import ListLightContent from "../list-light-content";
    import ModalSimpleSuccess from "../custom-modals/modal-simple-success";

    const productService = new ProductService(),
        authService = new AuthService();

    export default {
        name: 'grid-client-review',
        components: {ModalSimpleSuccess, ListLightContent, StarRating},
        props: ['product'],
        data: () => {
            return {
                loading: false,
                errors: [],
                user: {
                    rating: null,
                    review: null
                }
            }
        },
        mounted() {
        },
        methods: {
            reset() {
                this.user.rating = null;
                this.user.review = null;
            },
            send() {
                if (!authService.isSigned()) return PubSub.publish('openLoginModal');
                if (this.user.rating && this.user.review) {

                    this.loading = true;
                    this.errors = [];

                    productService.doSendReview(this.product.id, this.user.review, this.user.rating)
                        .then(
                            () => {
                                PubSub.publish('openClientReviewModal');
                                this.loading = false;
                                this.reset();
                            },
                            (err) => {

                                if (err.response && err.response.status === 401) {
                                    PubSub.publish('openLoginModal');
                                }

                                if (err.response && err.response.status === 422) {
                                    const errValidations = err.response.data.error.validations;
                                    for (const j in errValidations) {
                                        if (errValidations.hasOwnProperty(j) && this.user[j]) {
                                            this.user[j].errors = errValidations[j];
                                        }
                                    }
                                } else {
                                    this.errors = [err.response.data.error.message];
                                }

                                this.loading = false;
                            }
                        );
                }
            }
        }
    }
</script>



// WEBPACK FOOTER //
// resources/site/js/components/grids/grid-client-review.vue